import React from 'react';
import { NavLink } from 'react-router-dom';
import RouterPaths from '../../constants/RouterPaths';

function SellStockSection({ title, subtitle }) {
  return (
    <div className="text-center">
      <h2 className="sell-stock-section__heading">{title}</h2>
      <p className="sell-stock-section__text">{subtitle}</p>
      <div className="sell-stock-section__buttons">
        <NavLink to={RouterPaths.REGISTER} className="common-button red-button w-100">
          Register account
        </NavLink>
        <NavLink to={RouterPaths.LOGIN} className="common-button outline-red w-100">
          Login
        </NavLink>
      </div>
    </div>
  );
}

export default SellStockSection;
